import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";
import { captureAttribution } from "@/lib/attribution";
import { captureSrcTracking } from "@/lib/srcTracking";

/** Fires one PageView (Meta Pixel + GA4) per route, including the initial
 * load - the base snippets in public/index.html only `init`/`config`, they
 * do not send an initial PageView themselves, so this is the single source
 * of truth for all page_view/PageView events (no double counting). Also
 * captures UTM/click-ID attribution into the rh_attrib cookie on every route
 * change, so a paid landing anywhere on the site is picked up. */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    captureAttribution();
    captureSrcTracking();
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
